import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=275f429d&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=275f429d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f429d",
  null
  
)

export default component.exports